export enum AlertType {
  APPROVED = 'approved',
  DEFAULT = 'default', //none
  DENIED = 'denied',
  EXPIRED = 'expired',
  LIGHT = 'light',
  NOT_SENT = 'not-sent',
  PENDING = 'pending',
  PRIMARY = 'primary',
  PROCESS = 'process',
  WAITING = 'waiting',
  WAIVER = 'waiver'
}

export enum AlertSize {
  DEFAULT = 'default',
  LARGE = 'large'
}

export enum AlertTextType {
  ALERT = 'alert',
  ALERT_WRAP = 'alert-wrap'
}

export enum AlertCardType {
  DEFAULT = 'default',
  SPACE = 'space'
}